export default function onBridgeReady(data) {
	console.log(data);
	return new Promise((resolve, reject) => {
		WeixinJSBridge.invoke(
			'getBrandWCPayRequest',
			{
				appId: data.appId, //公众号ID，由商户传入
				timeStamp: data.timestamp, //时间戳，自1970年以来的秒数
				nonceStr: data.nonceStr, //随机串
				package: data.package,
				signType: data.signType, //微信签名方式：
				paySign: data.paySign, //微信签名
			},
			function(res) {
				console.log(res.errMsg);
				if (res.err_msg == 'get_brand_wcpay_request:ok') {
					// 使用以上方式判断前端返回,微信团队郑重提示：
					//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
					resolve(true);
				}
				if (
					res.err_msg == 'get_brand_wcpay_request:cancel' ||
					res.err_msg == 'get_brand_wcpay_request:fail'
				) {
					reject(false);
				}
			}
		);
	});
}

function wechatJsApiPay(data) {
	if (typeof WeixinJSBridge == 'undefined') {
		if (document.addEventListener) {
			document.addEventListener(
				'WeixinJSBridgeReady',
				() => {
					onBridgeReady(data);
				},
				false
			);
		} else if (document.attachEvent) {
			document.attachEvent('WeixinJSBridgeReady', () => {
				onBridgeReady(data);
			});
			document.attachEvent('onWeixinJSBridgeReady', () => {
				onBridgeReady(data);
			});
		}
	} else {
		return onBridgeReady(data);
	}
}
